import type { FC, ReactElement } from "react"

import {
    ETypographyAlignment,
    ETypographyFamily,
    ETypographySize,
    ETypographyTag,
    ETypographyWeight,
    Typography
} from "@/3514/components"
import { type TScreenBreakpoints, type TUserState, useScreenBreakpoints, useUser } from "@/3514/hooks"
import { type IUseTranslation, useTranslation } from "@/hooks"

import classes from "./coach.dashboard.styles"

const CoachDashboardTitle: FC = (): ReactElement => {
    const {
        user: { firstName }
    }: TUserState = useUser()

    const { t }: IUseTranslation = useTranslation()

    const breakpoints: TScreenBreakpoints = useScreenBreakpoints()

    return (
        <div className={classes.title.container()}>
            <Typography
                tag={ETypographyTag.Heading1}
                weight={ETypographyWeight.Medium}
                alignment={breakpoints.xs || breakpoints.sm ? ETypographyAlignment.Center : ETypographyAlignment.Left}
                size={breakpoints.xs || breakpoints.sm ? ETypographySize.Heading2 : ETypographySize.Heading1}
                family={ETypographyFamily.DmSerif}
                text={t("coachSide.dashboard.title", { firstName })}
            />
        </div>
    )
}

CoachDashboardTitle.displayName = "CoachDashboardTitle"

export default CoachDashboardTitle
